// extracted by mini-css-extract-plugin
export default {"container":"StaffManagement_container__N+qTm","wrapperHeader":"StaffManagement_wrapperHeader__eCKqE","row":"StaffManagement_row__5IHnS"};